var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYnaLogoRect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 36,
    viewBox: "0 0 152 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9858C0 8.05252 8.05252 0 17.9858 0C27.9191 0 35.9716 8.05252 35.9716 17.9858C35.9716 27.9191 27.9191 35.9716 17.9858 35.9716C8.05252 35.9716 0 27.9191 0 17.9858Z",
    fill: "#FF3147"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7347_12791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2105 23.9082L14.6641 18.7534L16.5849 16.452L19.93 19.5602L27.9368 9.96387L30.2719 11.8492L20.2105 23.9082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35375 23.9082L6.01172 22.023L16.0842 9.96387L21.6195 15.0975L19.6966 17.4031L16.365 14.3119L8.35375 23.9082Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7347_12791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8903 31.5732L87.8496 21.2998L91.6731 16.7132L98.3318 22.9077L114.27 3.78271L118.918 7.54002L98.8903 31.5732Z",
    fill: "#FF3147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4683 31.5902L70.8115 27.8329L90.8394 3.7998L101.846 14.0308L98.0223 18.6258L91.3979 12.4653L75.4683 31.5902Z",
    fill: "#FF3147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.352 27.6466L146.85 31.5733L141.973 25.7087H120.996L116.116 31.5733L111.614 27.6466L131.487 3.7998L151.352 27.6466ZM125.925 19.7857H137.047L131.487 13.1003L125.925 19.7857Z",
    fill: "#FF3147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0051 7.86992L63.1667 25.5259V31.5733H56.3616V25.5527L41.4717 7.86992L46.4722 3.7998L59.7549 19.5647L73.0045 3.7998L78.0051 7.86992Z",
    fill: "#FF3147"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7347_12791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6228,
    height: 14.4562,
    fill: "white",
    transform: "translate(6.01172 9.96387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7347_12791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.516,
    height: 28.4057,
    fill: "white",
    transform: "translate(41.3086 3.78271)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYnaLogoRect);
export default __webpack_public_path__ + "static/media/yna_logo_rect.d8040393462b00c12bca8fb36a9b5eb5.svg";
export { ForwardRef as ReactComponent };